import React from 'react';
import { PropTypes } from 'prop-types';
import { Divider } from '@material-ui/core';
import { PANTONES_PRINCIPALES } from '../tools/Pantones';
// import { PANTONES_PRINCIPALES } from '../../tools/Pantones';

TextTitleCS.propTypes = {
    title: PropTypes.string.isRequired
};

TextTitleCS.defaultProps = {
    title: 'Título'
}

function TextTitleCS(props) {
    return (<>
        <div style={{ margin: '0 0 30px 0' }}>
            <h2
                style={{
                    color: '#00549f',
                    fontSize: '1.8rem',
                    fontWeight: 700,
                    margin: 0,
                    textAlign: 'left' // 👈 Esto alinea el texto a la izquierda
                }}
            >
                {props.title}
            </h2>

            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Divider style={{ width: '25%', color: 'primary', background: PANTONES_PRINCIPALES.AMARILLO, height: 1 }} />
                <Divider style={{ width: '75%', color: 'primary', background: PANTONES_PRINCIPALES.GRIS, height: 1 }} />
            </div>
        </div>
    </>)
}

export default React.memo(TextTitleCS);